<template>
  <div class="login__section login">
    <form @submit.prevent="onSubmit">
      <BackIcon />
      <h4 class="header__text">Sign in</h4>
      <!-- <h6 class="text-danger" v-if="loginError">{{ loginError }}</h6> -->
      <div class="form-group my-4">
        <label for="" class="mb-2">Email address</label>
        <input
          type="email"
          class="form-control"
          name=""
          id=""
          aria-describedby="emailHelpId"
          placeholder=""
          v-model="userDetails.email"
          required
        />
        <small id="emailHelpId" class="form-text text-muted"></small>
      </div>

      <label for="" class="mb-2">Password</label>
      <div class="input-group mb-3">
        <input
          :type="passwordType ? 'text' : 'password'"
          class="form-control"
          name=""
          id=""
          placeholder=""
          v-model="userDetails.password"
          required
          aria-label="Recipient's username"
          aria-describedby="basic-addon2"
        />
        <span class="input-group-text" id="basic-addon2">
          <img
            src="@/assets/icons/eye-off.png"
            alt=""
            style="width: 20px"
            v-if="passwordType"
            @click="this.passwordType = !this.passwordType"
          />
          <img
            src="@/assets/icons/eye.png"
            alt=""
            style="width: 20px"
            v-else
            @click="this.passwordType = !this.passwordType"
          />
        </span>
      </div>

      <div class="row mt-2 mb-2 align-items-center">
        <div class="col-6 order-2 order-md-2"></div>
        <div class="col-6 text-right blue order-0 order-md-3 text--right">
          <router-link to="/forgot-password" class="blue text--right"
            >Forgot password</router-link
          >
        </div>
      </div>
      <input type="submit" value="SIGN IN" :disabled="disabled" />

      <p class="mt-3">
        <small style="font-weight: bold" class="pr-4">
          If you don’t have an account,</small
        >
        <router-link to="/register" class="blue pl-2"> Register</router-link>
      </p>
    </form>
  </div>
</template>

<script>
import BackIcon from '@/components/AppBackHistory.vue'
export default {
  components: {
    BackIcon,
  },
  data() {
    return {
      passwordType: false,
      userDetails: {
        email: '',
        password: '',
      },
      loginError: '',
      disabled: false,
      from: null,
    }
  },

  methods: {
    onSubmit() {
      this.$emit('loginUser', this.userDetails)
    },
  },
}
</script>

<style scoped>
@import url(../styles/style.css);
</style>
